import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-search',
  templateUrl: './blog-search.component.html',
})
export class BlogSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
